import React, { useEffect, useMemo, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useParams } from "react-router-dom";
import Dashboard from "../../../../Components/Icons/Dasboard";
import { useFormik } from "formik";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import * as yup from "yup";
import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuMobileNumber,
  NuSelect,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import Select from "react-select";
import FormikSelectTwo, { FormikSelectWithAdd, SelectProductWithError } from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useNumber } from "../../../../Context/ProjectIdContext";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import EditIcon from "../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../Components/Icons/Delete";
import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import DropDownAdd from "../../../../Components/Utils/selectAdd";
import DropDownAddSubCategory from "../../../../Components/Utils/selectAddSubCategory";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];
function CreateInvoiceOutgoing() {
  // const [loading, setLoading] = useState(false);
  const {officeId} =useParams();

  const currentDate = new Date().toISOString().split('T')[0];
  const {value:Tax ,getData:refTax} = useFetchMataData(`/dropdown/dropdown-details/`,'Tax_invoicesIncoming')
  const {value:ModeOfPayment ,getData:refModeOfPayment} = useFetchMataData(`/dropdown/dropdown-details/`,'ModeOfPayment_invoicesIncoming')
    const toast = useToast();
  const { data: user } = UseDropDown('/user/drop-down');
  const {value:category ,getData:refcategory} = useFetchMataData(`/dropdown/dropdown-details/`,'category_invoicesIncoming')

   const [image, setImage] = useState([]);
   // const [division, setDivision] = useState([]);
  const [customerName, setCusName] = useState(null);
  const [customerEmail, setCusEmail] = useState(null);
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [searchCustomer, setSearchCustomer] = useState("");

  const { data: customers, setDataCustomer } = UseCustomerDropDownNew(
    `/customers/drop-down/${officeId}/branch`,

    searchCustomer
  );  const [soTotal,setSoTotal] = useState([]);
  const {number} = useNumber()
  const [newItemData, setNewItemData] = useState({
    productId:"",
    product_unit: "",
    quantity:"",
 sno:""
 
  });
  const [createNew, setCreateNew] = useState({
    date: currentDate || "",
    amount: "",
    tax: "",
    totalAmount: "",
    modeOfPayment: "",
    paymentDueDate: currentDate || "",
    paymentReceivedOn: currentDate || "",
    comments: "",
    customerId: "",
    // "status": "Pendding",
    division: "",
    ref: "",
    coId: "",
    taxAmount:"",
    bankCharges:"",
    projectId:number,
    receivedAmount:"",
    balanceAmount:"",
    receivedOn:currentDate || "",
    costCode:"",
    description:"",
    category:"",
    debitTo:"",
   
    paymentReleasedOn:"",
   
  });
  const [selectedFile, setSelectedFile] = useState(null);

 function handleImageChange(e) {
  const maxFileSize = 200000000; // 200 MB
  const files = Array.from(e.target.files);
  let fileArr = [];

  files.forEach((item) => {
    if (item.size < maxFileSize) {
      fileArr.push(item);
    } else {
      toast.open({
        type: "warning",
        message: `File Size too big`,
        description: `${item.name} is removed and not uploaded`,
      });
    }
  });

  let tempArr = [];
  setSelectedFile(fileArr);

  fileArr.forEach((item) => {
    let fileName = item?.name;
    tempArr.push(fileName);
  });

  setImage(tempArr);
  console.log(tempArr, "temp");

  // 👉 Reset input so same file can be selected again
  e.target.value = null;
}

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
        }),
    onSubmit: async (value, { resetForm }) => {
      if (items.length === 0) {
        setError("Product table is empty");
        // setLoading(false)
  
        return;
      }
      
      let formData = new FormData();
      const valueWithItems = {
        ...value,
      products: items,
       
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      addFormData("/invoices-outgoing/new-invoice", formData, resetForm);
      // setLoading(false)
    },
  });

  useMemo(() => {
    if (formik.values.tax != 0 || formik.values.tax != "") {
      let finalAmount = (formik.values.amount / 100) * formik.values.tax;
      formik.values.totalAmount = formik.values.amount + finalAmount;
    } else {
      formik.values.totalAmount = formik.values.amount;
    }
  }, [formik.values.amount, formik.values.tax]);

  const [Colist, setColist] = useState([]);
  // console.log("bnmbnm",Colist);


  const getPo = (coId) => {
    if (coId !== "") {
      axiosInstance
        .get(`/sales-order/${coId}`)
        .then(res => {
          console.log("nbnb",res?.data?.data?.products);
          let data = res?.data?.data?.products;
          let name = res.data?.data?.customerName;
          let email = res.data?.data?.customerEmail;
          let total = res?.data?.data?.subTotal.toFixed(2)
          setColist(data);
          name && setCusName(name);
          email && setCusEmail(email);
          total && formik.setFieldValue('amount',total)
          formik.setFieldValue('customerId',res.data?.data?.customerId)
          formik.setFieldValue('totalAmount',total)
        })
        .catch(err => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.coId) {
      getPo(formik.values.coId);
    }
  }, [formik.values.coId]);

  useEffect(() => {
    const amount = parseFloat(formik.values.amount || 0);
    const tax = parseFloat(formik.values.tax || 0);
    
    const taxAmount = ((amount)* tax/100);  
    
    formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
    formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
  }, [formik.values.amount, formik.values.tax]);

  useEffect(() => {
    const total = formik.values.totalAmount || 0;
    const paid = formik.values.receivedAmount || 0;
    const balance = total - paid;
  
    formik.setFieldValue("balanceAmount", parseFloat(balance.toFixed(2)));
  }, [formik.values.totalAmount, formik.values.receivedAmount]);

const [items, setItems] = useState([]);
const [search, setSearch] = useState("");
  
const [sortedProList,setSortedProList] =  useState([]);
const [oldData, setOldData] = useState([])

const { data: Item, setData } = UseProductDropDownNew(
  `/items/new-drop-down/${officeId}/branch`,
  search
); 

useEffect(()=>{
  if(Item){
    const union = Array.from(
      new Map([...Item, ...oldData].map((item) => [item.value, item])).values()
    );
    let data = union.sort((a, b) => a.label.localeCompare(b.label))
    setSortedProList(data)
  }    
},[Item])

useEffect(() => {
  if (formik.values.productId) {
    const findValue = sortedProList.filter((v) => formik.values?.productId ==(v.value));
    setOldData(findValue);
  }
  console.log("Testing",formik.values.productId);
},[formik.values.productId])

const { value: product_unit, getData: refUnit } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Unit_item"
);
const [isEditQua, setIsEditQua] = useState(false);
const [isEditUnit, setIsEditUnit] = useState(false);
const [error, setError] = useState("");
const [productError, setProductError] = useState("");
const [unitError, setUnitError] = useState("");
const [quantityError, setQuantityError] = useState("");
const handleAdd = () => {
  let hasError = false;

  if (!formik.values.productId) {
    setProductError("Product is required");
    hasError = true;
  } else {
    setProductError("");
  }

  if (!formik.values.product_unit) {
    setUnitError("Unit is required");
    hasError = true;
  } else {
    setUnitError("");
  }

  if (!formik.values.quantity) {
    setQuantityError("Quantity is required");
    hasError = true;
  } else {
    setQuantityError("");
  }

  if (hasError) return;

  if (formik.values.productId && formik.values.quantity) {
    const selectedProduct = Item.find(
      (i) => i.value === formik.values.productId
    );
    const newItem = {
      productId: formik.values.productId,
      productName: sortedProList.find((i) => i.value === formik.values.productId),
      quantity: formik.values.quantity,
      // unit:selectedProduct.unit
      product_unit: formik.values.product_unit,
    };
    setItems([...items, newItem]);

    setNewItemData({
      productId: "",
      quantity: "",
      product_unit: "",
      // unit:""
    });
    let updatedItems = Item.filter(
      (it) => it.value !== formik.values.productId
    );
    setData(updatedItems);
    formik.values.productId = "";
    formik.values.quantity = "";
    formik.values.product_unit = "";
    setError("");
  }
};

  const handleQuantityChange = (e, index) => {
    const updatedQuantity = e.target.value;

    // Update the specific item's quantity
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });

    setItems(updatedItems); // Update the state with new quantity
  };

  const handleProductUnitChange = (value, index) => {
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, product_unit: value?.value };
      }
      return item;
    });
    setItems(updatedItems);
  };

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = items.filter((_, index) => index !== indexToDelete);
    let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
    setItems(updatedItems);
    let tempDd = ddUpdatedItem.productName;
    setData([...Item, tempDd]);
    // localStorage.setItem("items", JSON.stringify(updatedItems));
  };

   const { value: customerType, getData: refcustomerType } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "customerType_Customer"
    );

    const [showPopup, setShowPopup] = useState(false);
  
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

   const resetFormCustomer = () => {
    formik.values.customerType = "";
    formik.values.companyName = "";
    formik.values.email = "";
    formik.values.cpCountryCode = "";
    formik.values.cpPhone = "";
    formik.values.cpName = "";
    formik.values.phone = "";
    formik.values.countryCode = "";
    formik.values.website = "";
    formik.values.industry = "";
    
    setShowPopup(false);
  };
  const handlePopupSubmit = async (e) => {
      e.preventDefault();
      let CompanyName = formik.values.companyName 
      const formData = new FormData();
      // formData.append('customerImage', JSON.stringify(newProduct));
      formData.append(
        "json_data",
        JSON.stringify({
          customerType: formik.values.customerType || "",
          companyName: formik.values.companyName || "",
          email: formik.values.email || "",
          cpCountryCode: formik.values.cpCountryCode || "",
          cpPhone: formik.values.cpPhone || "",
          cpName: formik.values.cpName || "",
          phone: formik.values.phone || "",
          countryCode: formik.values.countryCode || "",
          website: formik.values.website || "",
          industry: formik.values.industry || "",
      branchId: officeId,
  
        })
      );
      try {
        const response = await axiosInstance.post(
          `/customers/new-customer`,
          formData
        );
        const createdCustomer = response.data;
        if(createdCustomer?.status == true) {
          setDataCustomer((prevCustomers) => [
            ...prevCustomers,
            {
              label: CompanyName||"-",
              value: createdCustomer?.CI,
            },
          ]);
          resetFormCustomer();
        }else{
          toast.open({
            type:"warning",
            message:"Warning",
            description: createdCustomer.msg || "Warning."
          })
        }
        // if(response.data?.status){
        //   formik.resetForm();
        //   getCustomer()
        //   setShowPopup(false);
        // }
      } catch (error) {
        console.error("Error creating new Client:", error);
      }
    };
  const [showPop, setShowPop] = useState(false);

  const togglePop = () => {
    setShowPop(!showPop);
  };

  const resetForm = () => {
    formik.values.productName = "";
    formik.values.unit = "";
    formik.values.category = "";
    formik.values.subCategory = "";
    setShowPop(false);
  };

   const handlePopSubmit = async (e) => {
      e.preventDefault();
  
      const formData = new FormData();
      formData.append(
        "json_data",
        JSON.stringify({
          productName: formik.values.productName,
          unit: formik.values.unit,
          category: formik.values.category,
          subCategory: formik.values.subCategory,
      branchId: officeId,
  
        })
      );
  
      try {
        const response = await axiosInstance.post("/items/new-item", formData);
        const createdProduct = response.data?.data;
  
        setData((prevProducts) => [
          {
            label: formik.values.productName,
            value: createdProduct.id,
            unit: createdProduct.unit,
          }, // Add the new product at the start
          ...prevProducts,
        ]);
  
        resetForm();
      } catch (error) {
        console.error("Error creating new product:", error);
      }
    };
    const {
      category: itemsCategory,
      subCategory: itemsSubCategory,
      getCategory,
      fetchSubCategory,
    } = UseCatSubCatDropDown(
      "/category/ItemCategory",
      "ItemCategory",
      formik?.values?.category
    );

    const { value: Unit, } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Unit_item"
      );


  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
        {/* <Breadcrumb
          items={[
            {
              name: "Invoice-Outgoing",
              link: `/main/${officeId}/sales/invoice_outgoing`,
            },
            {
              name: "create",
            },
          ]}
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
      <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
      <div className=" w-full h-full pt-2 pb-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
          <div className="w-full">
                <p className="p-2 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Invoice Ougoing :
                </p>
              </div> 
              <NuInput
                          label="Description"
                          type="text"
                          formik={formik}
                          placeholder="Description"
                          name="description"
                          width="w-full md:w-1/2 lg:w-2/3"
                        />
                        <NuInput
                        type="text"
                        label="Cost Code "
                        placeholder="Cost Code"
                        formik={formik}
                        name="costCode"
                        width="w-full md:w-1/2 lg:w-1/3"
                        // isRequired={true}
                      />
                     

             <FormikSelectWithAdd
                            type="text"
                            label="Client"
                            placeholder="Client"
                            Options={customers}
                            formik={formik}
                            name="customerId"
                            width="w-full md:w-1/2 lg:w-1/3"
                            isRequired={true}
                            px="0"
                            handleClick={togglePopup}
                            setSearch={setSearchCustomer}
                            FixPosition={true}
                            PortalTarget={true}
                          />
             <FormikSelectTwo
              type="text"
              label="Debit To"
              placeholder="Debit To"
              Options={user}
              formik={formik}
              name="debitTo"
              width="w-full md:w-1/2 lg:w-1/3"
              // isRequired={true}
            />
                        
            <NuInput
              // value={soTotal}
              type="number"
              label="Amount"
              placeholder=" Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                label="Tax (%)"
                placeholder="Choose"
                Options={Tax}
                formik={formik}
                name="tax"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refTax}
                displayProperty={"Tax (%)"}
                propertyName={"Tax_invoicesIncoming"}
              />
        <NuInput
  type="text"
  label="Tax Amount"
  placeholder="Tax Amount"
  formik={formik}
  name="taxAmount"
  width="w-full md:w-1/2 lg:w-1/3"
  disabled={true}
/>
            <NuInput
              type="number"
              label="Total Amount"
              placeholder="Total Amount"
              formik={formik}
              name="totalAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />
<NuInput
              type="number"
              label="Received Amount"
              placeholder="Received Amount"
              formik={formik}
              name="receivedAmount"
              width="w-full md:w-1/2 lg:w-1/3"
             
            />
             <NuInput
              type="number"
              label="Balance Amount"
              placeholder="Balance Amount"
              formik={formik}
              name="balanceAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />
            {formik.values.receivedAmount && (
            <NuDate
              label="Received On"
              placeholder="Received On"
              formik={formik}
              name="receivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            />)}
           
            <NuDate
              label="Payment DueDate"
              placeholder="Payment DueDate"
              formik={formik}
              name="paymentDueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuDate
              label="Payment ReceivedOn"
              placeholder="Payment ReceivedOn"
              formik={formik}
              name="paymentReceivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                label="Mode Of Payment"
                placeholder="Choose"
                Options={ModeOfPayment}
                formik={formik}
                name="modeOfPayment"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refModeOfPayment}
                displayProperty={"Mode Of Payment"}
                propertyName={"ModeOfPayment_invoicesIncoming"}
              />
            <DropDownAddMetaData
              label="Category"
              placeholder="Choose"
              Options={category}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refcategory}
              displayProperty={"category"}
              propertyName={"category_invoicesIncoming"}
            />
 
            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              new_width="w-full md:w-2/3"

              width="w-full md:w-1/2 lg:w-1/3"
            />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            
            <div className="w-full flex px-6">
            {formik.values.coId && (
              <>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Name
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerName}
                  </p>
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Email
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerEmail}
                  </p>
                </div>
              </>
            )}
            </div>
             <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
             <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Products :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={togglePop}
                  setSearch={setSearch}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={product_unit}
                  formik={formik}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  FixPosition={false}
                  PortalTarget={false}
                />
                {/* <button
                  onClick={togglePop}
                  type="button"
                  className=" p-3 py-2 mt-9  text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                  
                  +
                </button> */}
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />
                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-textColor-main flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center  text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6  odd:bg-white even:bg-slate-50"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName?.label||""}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {/* {List?.unit} */}
                            <Select
                              value={
                                product_unit.find(
                                  (item) => item?.value == List.product_unit
                                ) || List.product_unit
                              }
                              options={isEditUnit ? product_unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}
              </div>
              <div className="w-full  mx-auto my-4 mt-8 pb-2">
                <div className="flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>

           
          </div>
        </div>
      </form>

       {showPopup && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
                  <form onSubmit={handlePopupSubmit}>
                    <div className="mb-4 flex flex-wrap">
                      <DropDownAddMetaData
                        label="Client Type"
                        placeholder="Choose"
                        Options={customerType}
                        formik={formik}
                        name="customerType"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={refcustomerType}
                        displayProperty={"Customer Type"}
                        propertyName={"customerType_Customer"}
                        FixPosition={true}
                        PortalTarget={false}
                      />
      
                      <NuInput
                        type="text"
                        label="Company Name"
                        placeholder="Company Name"
                        formik={formik}
                        name="companyName"
                        isRequired={true}
                        width="w-full md:w-1/2 lg:w-1/2"
                      />
                      <NuMobileNumber
                        nunCode="countryCode"
                        label="Phone"
                        placeholder="Phone"
                        formik={formik}
                        isRequired={true}
                        name="phone"
                        width="w-full md:w-1/2 lg:w-1/2"
                        FixPosition={true}
                        PortalTarget={false}
                      />
                      <NuInput
                        type="email"
                        label="Email"
                        placeholder="Email"
                        formik={formik}
                        name="email"
                        width="w-full md:w-1/2 lg:w-1/2"
                        isRequired={true}
                      />
                      <NuInput
                        type="text"
                        label="Contact Person Name"
                        placeholder="Contact Person Name"
                        formik={formik}
                        isRequired={true}
                        name="cpName"
                        width="w-full md:w-1/2 lg:w-1/2"
                      />
                      <NuMobileNumber
                        nunCode="cpCountryCode"
                        label="Contact Person Phone"
                        placeholder="Contact Person Phone"
                        formik={formik}
                        name="cpPhone"
                        isRequired={true}
                        width="w-full md:w-1/2 lg:w-1/2"
                        FixPosition={true}
                        PortalTarget={false}
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePopup}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

      {showPop && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-medium text-[14px]">Add Product</h2>
                  <form onSubmit={handlePopSubmit}>
                    <div className="mb-4 flex flex-wrap">
                      <NuInput
                        label="Product Name"
                        type="text"
                        formik={formik}
                        placeholder="Product Name"
                        name="productName"
                        width="w-full"
                        isRequired={true}
                      />
      
                      <DropDownAddMetaData
                        label="Unit"
                        placeholder="Choose"
                        Options={Unit}
                        formik={formik}
                        name="unit"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={refUnit}
                        displayProperty={"Add Unit"}
                        propertyName={"Unit_item"}
                        isRequired={true}
                        FixPosition={true}
                        PortalTarget={false}
                        
                      />
                      <DropDownAdd
                        type="text"
                        label="Category"
                        placeholder="Category"
                        Options={itemsCategory}
                        formik={formik}
                        name="category"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={getCategory}
                        categoryName={"ItemCategory"}
                        displayProperty={"Add Category"}
                        isRequired={true}
                        FixPosition={true}
                        PortalTarget={false}
                      />
                      <DropDownAddSubCategory
                        type="text"
                        label="Sub-Category"
                        placeholder="Sub-Category"
                        Options={itemsSubCategory}
                        formik={formik}
                        name="subCategory"
                        width="w-full md:w-1/2 lg:w-1/2"
                        getFunc={fetchSubCategory}
                        category={formik?.values?.category}
                        module={"ItemCategory"}
                        displayProperty={"Add Sub-Category"}
                        FixPosition={true}
                        PortalTarget={false}
                      />
      
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePop}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
    </div>
  );
}

export default CreateInvoiceOutgoing;
